/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */
import { Grid } from '@mui/material';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import FormField from 'src/js/components/common/fields/FormField';

interface Props {
  formik: ReturnType<typeof useFormik>;
}

const AdobeAnalytics = ({ formik }: Props) => (
  <FormikProvider
    value={formik}
  >
    <Grid container>
      <Grid item xs={12}>
        <FormField
          type="text"
          name="adobeSettings.analyticsUrl"
          label="Analytics url"
        />
      </Grid>
    </Grid>
  </FormikProvider>
);

export default AdobeAnalytics;